import NodeKey from 'react-node-key'

// 根据 FiberNode 所处位置来确定 NodeKey
export default NodeKey
